import { render } from "./Resolutions.html?vue&type=template&id=7d0852f2&ts=true"
import script from "./Resolutions.vue?vue&type=script&lang=ts"
export * from "./Resolutions.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__